var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSimilarRightSlider(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 12,
    viewBox: "0 0 34 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.1334 5.99977L32.4 6.7331L32.092 7.0411L27.428 11.7051L26.3867 10.6638L30.3174 6.7331H0.866699V5.26643H30.3174L26.3867 1.33577L27.428 0.294434L32.092 4.9731L32.3854 5.26643L33.1334 5.99977Z",
    fill: "#282825"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimilarRightSlider);
export default __webpack_public_path__ + "static/media/similarRightSlider.7231c3cddcb91aefb5ae592364bdbdb5.svg";
export { ForwardRef as ReactComponent };